"use client";

import React from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImpactVisuelImmobilier() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="223331" id="the-smarter-way-to-exit" className="dark bg-background text-foreground relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1668124/img/modern_data_center_infrastructure.png)] bg-cover bg-center" />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-32 md:py-40 flex flex-col items-center text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <span className="inline-block px-4 py-2 rounded-md bg-transparent text-white text-[10px] sm:text-xs font-default font-medium tracking-[0.2em] uppercase mb-8 border border-white/20">
          BuyMyMSP • The Smarter Way to Exit
        </span>

        <h1 className="font-default text-4xl sm:text-5xl md:text-6xl lg:text-[72px] font-bold text-white leading-tight mb-6 tracking-tighter">
          Sell Your MSP for a Fraction of the Fee
        </h1>

        <p className="font-default text-[12px] text-white/80 max-w-2xl mb-10 leading-relaxed">
          We connect IT and MSP business owners directly with qualified buyers. Skip the traditional broker fees and maximize your exit value with our streamlined matching process.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Link to="mailto:inquiry@buymymsp.com">
            <Button size="lg" className="w-full sm:w-auto rounded-md bg-primary text-primary-foreground border-0 hover:opacity-90 transition-all px-8 py-6 text-sm sm:text-base shadow-lg animate-pulse">
              Inquire Now
            </Button>
          </Link>
          <Link to="/HomePage">
            <Button variant="outline" size="lg" className="w-full sm:w-auto rounded-md bg-transparent border-white/40 text-white hover:bg-white/10 hover:border-white transition-colors px-8 py-6 text-sm sm:text-base backdrop-blur-md">
              <Play className="w-4 h-4 sm:w-5 sm:h-5 mr-2 fill-current" />
              Valuation Guide
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}